import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { TextField, Box, Grid } from '@material-ui/core/';
import { useFormik } from 'formik';
import * as yup from 'yup';
import useRouterUtils from 'utils/router/routerUtilsHook';
import { BackButton } from 'components';
import useTableState from 'utils/table-state';
import LoadingButton from 'components/LoadingButton';
import { Form, fieldProps } from 'components/Form';
import useService from 'utils/services';

const validationSchema = yup.object({
  name: yup.string().required('Este campo es obligatorio'),
  code: yup.string().required('Este campo es obligatorio'),
});

const TeamsForm = ({ isEdit, title }) => {
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const { redirect } = useRouterUtils();
  const { id } = useParams();
  const { team } = useService();
  const { setShouldReload } = useTableState('teams');

  const onSubmit = async (values) => {
    setLoadingSubmit(true);
    if (isEdit) await team.patchTeam(values, id);
    else await team.postTeam(values);
    setLoadingSubmit(false);
    setShouldReload(true);
    redirect('/equipos');
  };

  const formik = useFormik({
    initialValues: {
      name: '',
      code: '',
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit,
  });

  const fetchData = async () => {
    if (isEdit && id) {
      const data = await team.fetchTeam(id);
      await formik.setFieldValue('name', data.name);
      await formik.setFieldValue('code', data.code);
    }
  };

  const GoBack = () => <BackButton to="/equipos" />;

  useEffect(fetchData, []);

  return (
    <div>
      <div className="TeamsForm">
        <Grid container justifyContent="center">
          <Grid item xs={4}>
            <Form
              onSubmit={formik.handleSubmit}
              title={title}
              HeaderComponent={GoBack}
            >
              <TextField
                fullWidth
                label="Nombre"
                margin="normal"
                id="name"
                name="name"
                className="name"
                {...fieldProps(formik, 'name')}
              />

              <TextField
                fullWidth
                label="Código"
                margin="normal"
                id="code"
                name="code"
                className="code"
                {...fieldProps(formik, 'code')}
              />

              <Box align="center">
                <LoadingButton loading={loadingSubmit} isEdit={isEdit} />
              </Box>
            </Form>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

TeamsForm.propTypes = {
  isEdit: PropTypes.bool,
  title: PropTypes.string,
};

TeamsForm.defaultProps = {
  isEdit: false,
  title: 'Nuevo team',
};

export default TeamsForm;
